import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface FilterSearchResultItemProps {
  onSelect: () => void;
  children: ReactNode;
}

/**
 * Result row for SearchableFilterSelect portals.
 * Select on mousedown so the choice sticks before the Select closes and unmounts the portal.
 */
export const FilterSearchResultItem = ({ onSelect, children }: FilterSearchResultItemProps) => (
  <Box
    role="button"
    p={3}
    cursor="pointer"
    _hover={{ bg: 'gray.50' }}
    borderBottom="1px solid"
    borderColor="gray.100"
    _last={{ borderBottom: 'none' }}
    onMouseDown={e => {
      e.preventDefault();
      onSelect();
    }}
  >
    {children}
  </Box>
);
